// extracted by mini-css-extract-plugin
module.exports = {"input-field":"Label_input-field__1TZJq","input-field__label":"Label_input-field__label__PNx0C","input-field__text":"Label_input-field__text__1wLb6"};